<div class="header-bar">
  <div class="header-left">
    <div class="header-text">
      {{ fromCustomer ? "Saved Customer Lists" : "Saved Audiences" }}
    </div>
    <div class="divider"></div>
    <button mat-button class="icon-btn" (click)="changeLayout('list')">
      <svg-icon
        src="assets/svg/list.svg"
        [svgStyle]="{
          'width.px': '26.5',
          'height.px': '23.5'
        }"
        [svgClass]="selectedView === 'list' ? 'lightGreen' : 'grey'"
      ></svg-icon>
    </button>
    <button mat-button class="icon-btn" (click)="changeLayout('grid')">
      <svg-icon
        src="assets/svg/grid.svg"
        [svgStyle]="{
          'width.px': '26.5',
          'height.px': '26.5'
        }"
        [svgClass]="selectedView === 'grid' ? 'lightGreen' : 'grey'"
      ></svg-icon>
    </button>
    <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
    <ng-container *ngIf="selectedView === 'grid'">
      <div class="divider"></div>
      <div class="sort-by">
        <div class="text">Sort by</div>
        <lhpe-select
          [options]="sortColumns"
          [formGroup]="sortFormGroup"
          controlName="sort"
        >
        </lhpe-select>
      </div>
    </ng-container>
    <div class="divider"></div>

    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input
          matInput
          (keyup)="applyFilter()"
          matInput
          type="text"
          [(ngModel)]="searchValue"
        />
      </mat-form-field>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right"></div>
</div>

<div class="audience-list">
  <div class="audience-grid-view" *ngIf="selectedView === 'grid'">
    <div
      *ngFor="let audience of filteredAudiences"
      class="container audience-container"
    >
      <div class="container-header no-bottom-border">
        <div class="text">{{ audience.name }}</div>
        <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="audienceMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu
            class="mat-menu-elaphant vertical-menu"
            #audienceMenu="matMenu"
          >
            <ng-container *ngIf="!fromCustomer">

              <button
                class="icon-btn-w-text"
                mat-menu-item
                (click)="viewAudience(audience)"
              >
                <svg-icon
                  src="assets/svg/audience.svg"
                  [svgStyle]="{
                    'width.px': '21.5',
                    'height.px': '21.805'
                  }"
                  svgClass="white"
                ></svg-icon>
                <span>View audience</span>
              </button>

              <button
                *ngIf="showEdit"
                class="icon-btn-w-text"
                mat-menu-item
                (click)="editAudience(audience)"
              >
                <svg-icon
                  src="assets/svg/pencil.svg"
                  [svgStyle]="{
                    'width.px': '21.441',
                    'height.px': '21.441'
                  }"
                  svgClass="white"
                ></svg-icon>
                <span>Edit audience</span>
              </button>
              
              <button
                *ngIf="showDelete"
                class="icon-btn-w-text"
                mat-menu-item
                (click)="deleteAudience(audience)"
              >
                <svg-icon
                  src="assets/svg/trashcan.svg"
                  [svgStyle]="{
                    'width.px': '22.5',
                    'height.px': '22.298'
                  }"
                  svgClass="white"
                ></svg-icon>
                <span>Delete audience</span>
              </button>
            </ng-container>

            <ng-container *ngIf="fromCustomer">

              <button
                class="icon-btn-w-text"
                mat-menu-item
                (click)="viewAudience(audience)"
              >
                <svg-icon
                  src="assets/svg/audience.svg"
                  [svgStyle]="{
                    'width.px': '21.5',
                    'height.px': '21.805'
                  }"
                  svgClass="white"
                ></svg-icon>
                <span>View audience</span>
              </button>

              <button
                *ngIf="showEdit"
                class="icon-btn-w-text"
                mat-menu-item
                (click)="editAudience(audience)"
              >
                <svg-icon
                  src="assets/svg/pencil.svg"
                  [svgStyle]="{
                    'width.px': '21.441',
                    'height.px': '21.441'
                  }"
                  svgClass="white"
                ></svg-icon>
                <span>Edit list</span>
              </button>
              <button
                *ngIf="showSendBroadcast"
                class="icon-btn-w-text"
                mat-menu-item
                (click)="sendBroadcastToList(audience)"
              >
                <svg-icon
                  src="assets/svg/send-broadcast.svg"
                  [svgStyle]="{
                    'width.px': '19.645',
                    'height.px': '21.445'
                  }"
                  svgClass="white"
                ></svg-icon>
                <span>Send Broadcast to list</span>
              </button>

              <button
                *ngIf="showDelete"
                class="icon-btn-w-text"
                mat-menu-item
                (click)="deleteAudience(audience)"
              >
                <svg-icon
                  src="assets/svg/trashcan.svg"
                  [svgStyle]="{
                    'width.px': '22.5',
                    'height.px': '22.298'
                  }"
                  svgClass="white"
                ></svg-icon>
                <span>Delete list</span>
              </button>
            </ng-container>
          </mat-menu>
        </div>
      </div>
      <div class="container-content">
        <div class="container-row">
          <div class="question">Created:</div>
          <div class="answer">
            <ng-container *ngIf="audience.created_at">
              {{ formatDate(audience.created_at) }}
            </ng-container>
            <ng-container *ngIf="!audience.created_at"> - </ng-container>
          </div>
        </div>
        <div class="container-row">
          <div class="question">Created by:</div>
          <div class="answer">
            {{ audience.created_by_name ? audience.created_by_name : "-" }}
          </div>
        </div>
        <div class="container-row">
          <div class="question">Last modified:</div>
          <div class="answer">
            <ng-container *ngIf="audience.modified_at">
              {{ formatDate(audience.modified_at) }}
            </ng-container>
            <ng-container *ngIf="!audience.modified_at"> - </ng-container>
          </div>
        </div>
        <div class="container-row">
          <div class="question">Modified by:</div>
          <div class="answer">
            {{ audience.modified_by_name ? audience.modified_by_name : "-" }}
          </div>
        </div>
        <div class="container-row">
          <div class="question">Total Broadcasts:</div>
          <div class="answer">
            <ng-container *ngIf="audience.last_used">
              {{ formatDate(audience.last_used) }}
            </ng-container>
            <ng-container *ngIf="!audience.last_used"> - </ng-container>
          </div>
        </div>
        <div class="container-row">
          <div class="question">Last broadcast:</div>
          <div class="answer">
            {{ audience.last_broadcast ? audience.last_broadcast : "-" }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="audience-list-view" *ngIf="selectedView === 'list'">
    <div class="container audience-list-container">
      <div class="container-header no-bottom-border">
        <div class="text">
          {{ fromCustomer ? "All Customer Lists" : "Audiences" }}
        </div>
        <div class="options">
          <button
            *ngIf="showNewAudience"
            mat-icon-button
            [matMenuTriggerFor]="audiencesMenu"
          >
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu
            class="mat-menu-elaphant vertical-menu"
            #audiencesMenu="matMenu"
          >
            <button
              *ngIf="showNewAudience"
              class="icon-btn-w-text"
              mat-menu-item
              (click)="createNewAudience()"
            >
              <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
              <span>Create New Audience</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <div class="container-content">
        <table
          #audienceTable
          mat-table
          [dataSource]="audienceDataSource"
          matSort
        >
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let row">
              {{ row.name ? row.name : "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.created_at">
                {{ formatDate(row.created_at) }}
              </ng-container>
              <ng-container *ngIf="!row.created_at"> - </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="created_by_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Created By
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.created_by_name ? row.created_by_name : "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="modified_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Last Modified
            </th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.modified_at">
                {{ formatDate(row.modified_at) }}
              </ng-container>
              <ng-container *ngIf="!row.modified_at"> - </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="modified_by_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Modified by
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.modified_by_name ? row.modified_by_name : "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="total_broadcasts">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Broadcasts</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.total_broadcasts">
                {{ row.total_broadcasts }}
              </ng-container>
              <ng-container *ngIf="!row.total_broadcasts"> - </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="last_broadcast_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Last Broadcast
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.last_broadcast_name ? row.last_broadcast_name : "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="options">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row" class="options-cell">

              <button
                *ngIf="fromCustomer && showSendBroadcast"
                mat-button
                (click)="sendBroadcastToList(row)"
                class="icon-btn"
              >
                <svg-icon
                  src="assets/svg/send-broadcast.svg"
                  svgClass="lightBlue"
                  [svgStyle]="{
                    'width.px': '16.268',
                    'height.px': '17.758'
                  }"
                ></svg-icon>
              </button>

              <button
                *ngIf="showEdit"
                mat-button
                (click)="editAudience(row)"
                class="icon-btn"
              >
                <svg-icon
                  src="assets/svg/pencil.svg"
                  svgClass="lightBlue"
                ></svg-icon>
              </button>

              <button
                mat-button
                (click)="viewAudience(row)"
                class="icon-btn"
              >
                <svg-icon
                  src="assets/svg/view.svg"
                  svgClass="lightBlue"
                ></svg-icon>
              </button>

              <div *ngIf="!showEdit" class="empty-btn-space"></div>
              <button
                *ngIf="showDelete"
                class="icon-btn"
                mat-button
                (click)="deleteAudience(row)"
              >
                <svg-icon
                  src="assets/svg/trashcan.svg"
                  [svgStyle]="{
                    'width.px': '15.25',
                    'height.px': '16.204'
                  }"
                  svgClass="lightBlue"
                ></svg-icon>
              </button>
              <div *ngIf="!showDelete" class="empty-btn-space"></div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
